import { colors } from '../../theme/colors';
import { tokens } from '../../theme/tokens';

export const chartTheme = {
  backgroundColor: 'transparent',

  yAxisColor: 'transparent',
  xAxisColor: colors.border.subtle,
  rulesColor: colors.border.subtle,
  rulesType: 'dashed' as const,

  yAxisTextStyle: {
    color: colors.text.muted,
    fontSize: tokens.fontSize.xs,
  },
  xAxisLabelTextStyle: {
    color: colors.text.muted,
    fontSize: tokens.fontSize.xs,
  },

  pointerStripColor: colors.border.subtle,
  pointerColor: colors.primary.neon,

  tooltipBackground: colors.background.elevated,
  tooltipBorder: colors.border.muted,
  tooltipText: colors.text.primary,
  tooltipFontSize: tokens.fontSize.sm,
};
